import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class UserService {

  env = environment;

  constructor(private readonly http: HttpClient) { }

  register(data: any) {
    const reqHeader = new HttpHeaders({ 'Content-Type': 'application/json', 'No-Auth': 'True' });
    return this.http.post(this.env.webApiUrl + 'api/user/Register', data, { headers: reqHeader });
  }

  updateGrossIncome(data: any) {
    return this.http.post(this.env.webApiUrl + 'api/user/UpdateUserGrossIncome', data);
  }


  validateToken(data: any) {
    const reqHeader = new HttpHeaders({ 'Content-Type': 'application/json', 'No-Auth': 'True' });
    return this.http.post(this.env.webApiUrl + 'api/user/ValidateToken', data, { headers: reqHeader });
  }

  createPassword(data: any) {
    return this.http.post(this.env.webApiUrl + 'api/user/CreatePassword', data);
  }

  validateIdNumber(data: any) {
    const reqHeader = new HttpHeaders({ 'Content-Type': 'application/json', 'No-Auth': 'True' });
    return this.http.post(this.env.webApiUrl + 'api/user/ValidateIdNumber', data, { headers: reqHeader });
  }

  registerWithIdNumber(data: any) {
    return this.http.post(this.env.webApiUrl + 'api/user/RegisterWithIdNumber', data);
  }

  getUserInfoByIdNumber(data: any) {
    return this.http.post(this.env.webApiUrl + 'api/user/GetUserInfoByIdNumber', data);
  }

  getUserFinancialPlannerCode() {
    return this.http.post(this.env.webApiUrl + 'api/user/GetUserFinancialPlannerCode', null);
  }

  registerIvrUserWithIdNumber(data: any) {
    return this.http.post(this.env.webApiUrl + 'api/user/RegisterIvrUserWithIdNumber', data);
  }

  fetchUserDetailsByIdNumber(idNumber: string){
    return this.http.post(this.env.webApiUrl + 'api/user/FetchUserDetailsByIdNumber?idNumber='+idNumber, null);
  }

  sendSignal(data: any) {
    const reqHeader = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(this.env.webApiUrl + 'api/User/SendSignalData', data, { headers: reqHeader });
  }
}
